/**
 *
 **/
export default class DaisyValidationService {
    getIsDaisyOrder(item){
        let isDaisyOrder = false;
        angular.forEach(item.positionen, (position) => {
            if(position.transportgutObjekte.length > 0){
                isDaisyOrder = true;
            }
        });

        return isDaisyOrder;
    }
}